import React, { useEffect, useState } from 'react'
import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Grid from '@mui/material/Grid'
import { Container } from '@mui/material'
import InvestmentValue from './cards/InvestmentValue'
import RepartitionInvestments from './cards/RepartitionInvestments'
import UserTarget from './cards/UserTarget'
import AdviceCard from './cards/AdviceCard'
import PortfolioCard from './cards/PortfolioCard'
import OpportunityCard from './cards/OpportunityCard'
import { makeGetRequest } from 'utils/api'

const Item = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: 'rgb(0, 27, 66)',
  color: 'white',
  //   height: '100%',
  height: 450,
  overflow: 'hidden',
}))

export default function PortFolioTab() {
  const [reports, setReports] = useState([])
  useEffect(() => {
    getInvestments()
  }, [])
  const getInvestments = async () => {
    const { data } = await makeGetRequest('/api/investment/reports/', {}, true)
    setReports([...data])
  }
  return (
    <>
      <Box sx={{ flexGrow: 1, pb: 6, mt: 1 }}>
        <Grid container spacing={1}>
          <Grid item xs={12} md={5} lg={3.5}>
            <Item>
              <InvestmentValue report={reports.find((r) => r.type === 'valeur-investment')?.data} />
            </Item>
          </Grid>
          <Grid item xs={12} md={7} lg={5}>
            <Item>
              <PortfolioCard />
            </Item>
          </Grid>
          <Grid item xs={12} md={5} lg={3.5}>
            <Item>
              <AdviceCard />
            </Item>
          </Grid>
        </Grid>
        <Grid mt={1} container spacing={1}>
          <Grid item xs={12} md={5} lg={3.5}>
            <Item>
              <RepartitionInvestments
                report={reports.find((r) => r.type === 'breakdown-investment')?.data}
              />
            </Item>
          </Grid>
          <Grid item xs={12} md={7} lg={5}>
            <Item>
              <OpportunityCard />
            </Item>
          </Grid>
          <Grid item xs={12} md={5} lg={3.5}>
            <Item>
              <UserTarget report={reports.find((r) => r.type === 'user-target')?.data} />
            </Item>
          </Grid>
        </Grid>
      </Box>
    </>
  )
}
